




















import { Component, Vue, Prop } from "vue-property-decorator";
import { Circle2 } from "vue-loading-spinner";

import { CrudModel } from "../../models/crud";
import FormField from "./FormField.vue";

@Component({
	components: { FormField, Circle2 },
})
export default class CreationCard extends Vue {
	@Prop()
	entityModel: CrudModel;

	@Prop()
	fields: { key: string; class: string; props: any }[];

	@Prop()
	defaultEntity: any;

	schema: any[] = [];
	entity: any = {};

	async mounted() {
		if (this.defaultEntity) {
			Object.assign(this.entity, this.defaultEntity);
		}
		if (this.entityModel) {
			this.schema = await this.entityModel.getDescription();
		}
	}

	loading = false;
	async createEntity() {
		if (!this.entityModel) {
			this.$emit("send");
			return;
		}
		this.loading = true;
		try {
			await this.entityModel.create(this.entity);
			this.$toasted.success("Registro cadastrado");
			// Restaurar os valores padrão após a criação
			this.entity = this.defaultEntity ? { ...this.defaultEntity } : {};
			this.$emit("createdEntity");
		} catch (error) {
			console.error(error);
			const errorMessage = error && typeof error === "object" && "friendlyMessage" in error ? (error as any).friendlyMessage : "Erro ao cadastrar";
			this.$toasted.error(errorMessage);
		}
		this.loading = false;
	}
}
